<template>
  <div class="col s12 no-padding full-height-percent">
    <div class="row application-support app-body-height">
      <div class="col no-padding left-align">
        <div>
          <h5 class="blue-color">{{ $t('views.login.supportscreenheader') }}</h5>
          <p> {{ $t('views.navbar.supportdescription') }} </p>
          <p> <a
          :href="`mailto:${applicationSupport.emailaddress}`"
          target="_top">{{ applicationSupport.emailname}}</a> </p>
        </div>
      </div>
    </div>
    <div class="row app-footer-height app-footer-margins">
      <div class="col s6 left-align no-padding">
        <a
          class="blue-color"
          @click="$router.go(-1)">
        <p class="no-margin cursor-hand"><b>{{ $t('views.login.back') }}</b></p></a>
      </div>
      <div class="col s6 right-align no-padding">
        <p class="no-margin grey-color">{{ this.$parent.versionNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '../../services/AuthenticationService'
import organisationApi from '../../services/api/OrganisationsApi'
export default {
  data () {
    return {
      currentUser: AuthenticationService.getUser(),
      organisation: null,
      applicationSupport: {
        emailaddress: 'possteam@strukton.com',
        emailname: 'POSS team'
      }
    }
  },
  methods: {
    async getOrganisation () {
      await organisationApi.getOrganisation(this.currentUser.OrganisationId).then(result => {
        this.organisation = result.data
        if (this.organisation !== null) {
          this.applicationSupport.emailaddress = this.organisation.ServiceEmailAdress ? this.organisation.ServiceEmailAdress : 'possteam@strukton.com'
          this.applicationSupport.emailname = this.organisation.ServiceContactName ? this.organisation.ServiceContactName : 'POSS team'
        }
      })
    }
  },
  watch: {
    'currentUser': {
      immediate: true,
      handler: function (val, oldVal) {
        if (this.currentUser !== null) {
          this.getOrganisation()
        }
      }
    }
  }
}
</script>

<style scoped>
  .application-support {
    padding-top: 184px;
    padding-left: 53px;
    padding-right: 49px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/_Support.vue